(function() {
    angular.module('NaviaqWebApp').constant('appVersion','25.06.20.1026');
})();
